module.exports = __webpack_public_path__ + "img/law.b8f48d37.svg";